import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import getScrollBehavior from '../utils/get-scroll-behavior';

/** Scrolls the element into view each time `scrollKey` changes to a value; undefined leaves it where it is. */
const useScrollIntoView = scrollKey => {
  const $ = _c(3);
  const ref = useRef(null);
  let t0;
  let t1;
  if ($[0] !== scrollKey) {
    t0 = () => {
      if (scrollKey !== undefined) {
        ref.current?.scrollIntoView({
          block: "nearest",
          behavior: getScrollBehavior()
        });
      }
    };
    t1 = [scrollKey];
    $[0] = scrollKey;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return ref;
};
export default useScrollIntoView;